/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Controller } from 'react-hook-form';

export const PasswordField = ({ name, label, control }: { name: string; label: string; control: any }) => (
  <div className=" w-full md:w-1/3">
    <Label>
      <p className=" mb-2 text-sh-xs text-sh-grey-400">{label}</p>
    </Label>
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => <Input type="password" {...field} />}
    />
  </div>
);
